module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-light-6ff5a34c59e50b8e9a1d2dca2c3a1642.svg";